import React from "react";
import PropTypes from "prop-types";
import styled from "theme/libs/styled";
import SVG from "theme/components/icons/base/SVG";

const StyledSVG = styled(SVG)`
    & > * {
        transition: transform ${({ theme }) => theme.transitions.secondary};
    }
`;

const FilterIcon = ({ color, ...props }) => (
    <StyledSVG fill="none" className="filter-icon" {...props}>
        <line className="first" x1="4.5" y1="2" x2="4.5" y2="7" stroke={color} />
        <line className="second" x1="9.5" y1="7" x2="9.5" y2="12" stroke={color} />
        <line y1="4.5" x2="14" y2="4.5" stroke={color} />
        <line y1="9.5" x2="14" y2="9.5" stroke={color} />
    </StyledSVG>
);

FilterIcon.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

FilterIcon.defaultProps = {
    color: "currentColor",
    height: "14px",
    viewBox: "0 0 14 14",
    width: "14px",
};

export default FilterIcon;
